import { useTranslation } from 'react-i18next';

import { StatusBadge } from '../../../components/design-system/admin';
import { jobStatusMeta } from './queue-monitor.utils';

/** A job's status as a dot and a word (a status the page doesn't know reads as itself). */
export function JobStatusBadge({ status }: { status?: string }) {
    const { t } = useTranslation();
    const meta = jobStatusMeta(status);
    return (
        <StatusBadge tone={meta.tone} className={meta.key ? undefined : 'capitalize'}>
            {meta.key ? t(meta.key) : meta.raw || '—'}
        </StatusBadge>
    );
}
